type QueuedJob<T> = {
  execute: () => Promise<T>;
  resolve: (value: T) => void;
  reject: (reason?: unknown) => void;
};

/** Limits concurrent geodanmark WMS fetches so hung tiles do not occupy all browser connections. */
export class GeodanmarkTileFetchQueue {
  private inFlight = 0;

  constructor(private readonly maxConcurrent: number) { }

  private readonly queue: QueuedJob<unknown>[] = [];

  fetch<T>(execute: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue.push({
        execute,
        resolve: resolve as (value: unknown) => void,
        reject,
      });
      this.pump();
    });
  }

  private pump() {
    while (this.inFlight < this.maxConcurrent && this.queue.length > 0) {
      const job = this.queue.shift()!;
      this.inFlight++;
      job.execute()
        .then(job.resolve)
        .catch(job.reject)
        .finally(() => {
          this.inFlight--;
          this.pump();
        });
    }
  }
}
